import { ProjectCard } from "../../components/ProjectCard/index";

export const Projects = () => {
  return (
    <div>
      <ProjectCard />
    </div>
  );
};
